<template>
  <div>
    <h5 class="subheading">{{ 'app.interview.work'|trans }}</h5>
    <span v-if="interview.work">{{ `app.interview.works.` + interview.work | trans }}</span>
    <span v-else>{{ `app.no_data`| trans }}</span>
    <h5 class="mt-4 subheading">{{ 'app.interview.work_hours'|trans }}</h5>
    <pre v-if="interview.work_hours">{{ interview.work_hours }}</pre>
    <span v-else>{{ `app.no_data`| trans }}</span>
    <h5 class="mt-4 subheading">{{ 'app.interview.eating_habits'|trans }}</h5>
    <pre v-if="interview.eating_habits">{{ interview.eating_habits }}</pre>
    <span v-else>{{ `app.no_data`| trans }}</span>
    <h5 class="mt-4 subheading">{{ 'app.interview.previous_diet'|trans }}</h5>
    <pre v-if="interview.previous_diet">{{ interview.previous_diet }}</pre>
    <span v-else>{{ `app.no_data`| trans }}</span>
    <h5 class="mt-4 subheading">{{ 'app.interview.stress'|trans }}</h5>
    <span v-if="interview.stress">{{ `app.interview.stresses.` + interview.stress | trans }}</span>
    <span v-else>{{ `app.no_data`| trans }}</span>
    <h5 class="mt-4 subheading">{{ 'app.interview.equipments'|trans }}</h5>
    <span v-if="equipments">{{ equipments }}</span>
    <span v-else>{{ `app.no_data`| trans }}</span>
    <h5 class="mt-4 subheading">{{ 'app.interview.supplements'|trans }}</h5>
    <pre v-if="interview.supplements">{{ interview.supplements }}</pre>
    <span v-else>{{ `app.no_data`| trans }}</span>
  </div>
</template>
<script>
import { mapGetters} from "vuex";

export default {
  computed: {
    ...mapGetters(['interview']),
    equipments: function () {
      return this.interview.equipments.map(equipment => equipment.name).join(', ');
    },
  },
}
</script>
<style scoped>
pre {
  background-color: white;
  border: none;
  padding: 0;
  margin: 0;
  font-size: 14px;
  line-height: 21px;
  font-family: Roboto, sans-serif;
  color: rgba(0, 0, 0, .87);
  white-space: pre-wrap;
}
</style>